<template>
	<div id="app">
		<el-backtop></el-backtop>
		<router-view></router-view>
	</div>
</template>

<script>

import { session } from './storage/storage';

export default {
	name: 'app',
	components: {

	},
	created() {
		sessionStorage.removeItem('page')
		document.documentElement.style['overflow-x'] = 'hidden'
		// if(!session.get("lang")){
		session.set("lang", 'en')
		// }
		if (!session.get("channel_id")) {
			session.set("channel_id", 1)
		}
		// if(localStorage.get('channel_id')){
		// 	session.set("channel_id",localStorage.get('channel_id'))
		// }
	},
	watch: {
		$route(to, from, query) {
			if (this.$route.query.channel_id) {
				sessionStorage.setItem('channel_id', this.$route.query.channel_id)
			}
			if (to.fullPath == '/') {

				if (from.fullPath !== '/') {
					sessionStorage.removeItem('page')
					return
				}
				let page = sessionStorage.getItem('page')
				if (!!page) {
					let data = JSON.parse(page)
					if (!data.data) {
						this.$router.push({ path: './' + data.name })
					} else {
						this.$router.push({ path: './' + data.name, query: { e: data.e } })
					}
				}
			} else {
				if (from.fullPath == '/') {
					return
				}
				let to_str = to.fullPath[1] + to.fullPath[2]
				let from_str = from.fullPath[1] + from.fullPath[2]

				if (to_str !== from_str) {
					this.$nextTick(function () {  //页面加载完成后执行
						location.reload()
					})
				}
			}

		}
	},
}
</script>

<style>

@font-face {
  font-family: 'HarmonyOS_Sans_SC_Medium';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250726/HarmonyOS_Sans_SC_Medium.ttf') format('truetype');
}

@font-face {
  font-family: 'HarmonyOS_Sans_SC_Regular';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250726/HarmonyOS_Sans_SC_Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'HarmonyOS_Sans_Bold';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20250726/HarmonyOS_Sans_Bold.ttf') format('truetype');
}

@font-face {
  font-family: 'OPPOSans-H';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/OPPOSans-H.ttf') format('truetype');
}

@font-face {
  font-family: 'OPPOSans-M';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/OPPOSans-M.ttf') format('truetype');
}
@font-face {
  font-family: 'segoesc';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251216/segoesc.ttf') format('truetype');
}

@font-face {
  font-family: 'MiSans-Demibold';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/fonts/MiSans-Demibold.ttf') format('truetype');
}

@font-face {
  font-family: 'MiSans-Medium';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/fonts/MiSans-Medium.ttf') format('truetype');
}

@font-face {
  font-family: 'MiSans-Normal';
  src: url('https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/fonts/MiSans-Normal.ttf') format('truetype');
}

body {
	margin: 0;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
}

.contactup-right input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
}

.contactup-right input::-webkit-input-placeholder,
textarea:-moz-placeholder {
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
}

.contactup-right input::-webkit-input-placeholder,
textarea::-moz-placeholder {
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
}

.contactup-right input::-webkit-input-placeholder,
textarea::-ms-input-placeholder {
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
}

::-webkit-scrollbar-x {
	width: 0 !important;
}

::-webkit-scrollbar-x {
	width: 0 !important;
}

::-webkit-scrollbar-x {
	width: 0 !important;
	height: 0;
}

.vjs-big-play-button {
	left: 50% !important;
	top: 50% !important;
	margin-top: -1em;
	margin-left: -1.5em;
}

.woodpecker.bg {
	background-color: #e62129;

}

.dte.bg {
	background-color: #1a4698;

}

.dba.bg {
	background-color: #5d5f5f;

}

.woodpecker.theme--color {
	color: #e62129;

}
.dte.theme--color {
	color: #1a4698;

}
.dba.theme--color {
	color: #000000;

}
.focus-message {
	font-size: 26px;
}
.swiper-container.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
    margin: 0;
    border-radius: 0;
    width: 120px;
	height: 3px;
}
/* 最后一个 */
.swiper-container.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet:last-child{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
/* 第一个 */
.swiper-container.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet:first-child{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 20px !important;
}

.shadow{
  box-shadow: 0 5px 18px -2px rgba(0, 0, 0, 0.12);

}
.b-radius {
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  -moz-border-radius: 20px;
  overflow: hidden;
}

.flex {
  display: flex;
}

.bottom-align {
  display: flex;
  align-items: flex-end;
  line-height: 1;
}
.txt-center{
  text-align: center;
}
.mt-4 {
  margin-top: 40px!important;
}
.mt-25 {
  margin-top: 25px!important;
}
.mt-15 {
  margin-top: 15px!important;
}
.mt-40 {
  margin-top: 40px!important;
}
.mt-44 {
  margin-top: 44px!important;
}
.mt-50 {
  margin-top: 50px!important;
}
.mt-60 {
  margin-top: 60px!important;
}
.pb-20 {
  padding-bottom: 20px!important;
}
.pb-30 {
  padding-bottom: 30px!important;
}

.font-size-16 {
  font-size: 16px!important;
}

.font-size-64 {
  font-size: 64px!important;
}

.line-height-16 {
  line-height: 1.6!important;
}
.line-height-14 {
  line-height: 1.4!important;
}
</style>
